import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTabsModule } from '@angular/material/tabs'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { DirectivesModule } from '@mmx/shared'
import { SatPopoverModule } from '@ncstate/sat-popover'
import { TranslateModule } from '@ngx-translate/core'

import { AppointmentPortalMenuModule } from '../appointment-portal-menu'
import { EligibilityCardModule } from '../eligibility-card'
import { AppointmentEstimateCardComponent } from './appointment-estimate-card.component'

@NgModule({
  imports: [
    AppointmentPortalMenuModule,
    CommonModule,
    DirectivesModule,
    EligibilityCardModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    RouterModule,
    SatPopoverModule,
    TranslateModule,
  ],
  exports: [
    AppointmentEstimateCardComponent,
  ],
  declarations: [
    AppointmentEstimateCardComponent,
  ],
  providers: [],
})
export class AppointmentEstimateCardModule { }
